import { z } from "zod";
export var binderTypeEnumSchema = z.union([z.literal("Project"), z.literal("Facility"), z.literal("Procurement"), z.literal("Organization"), z.literal("Assignment"), z.literal("Selection"), z.literal("UnsupportedBinderType"), z.literal("NotApplicable")]);
export var logoTypeSchema = z.object({
    name: z.string().optional().nullable(),
    url: z.string().optional().nullable(),
    documentId: z.string()
});
export var coordinatesSchema = z.object({
    latitude: z.number().optional(),
    longitude: z.number().optional()
});
export var binderStateSchema = z.union([z.literal("Active"), z.literal("Archived"), z.literal("Warranty")]);
export var valueTypeEnumSchema = z.union([z.literal("String"), z.literal("Integer"), z.literal("Number"), z.literal("Boolean"), z.literal("Guid"), z.literal("Date")]);
export var metadataDefinitionSchema = z.object({
    metadataElementId: z.string().optional().nullable(),
    value: z.string().optional().nullable(),
    valueId: z.string().optional().nullable()
});
export var stringIdNamePairSchema = z.object({
    id: z.string().optional().nullable(),
    name: z.string().optional().nullable()
});
export var locationSchema = z.object({
    address: z.string().optional().nullable(),
    coordinates: coordinatesSchema.optional()
});
//# sourceMappingURL=Binder.zod.js.map